// extracted by mini-css-extract-plugin
module.exports = {"Container":"Form-Container-2szRNb","Header":"Form-Header-1YbGIV","Controls":"Form-Controls-3XYxAH","ArrowIcon":"Form-ArrowIcon-18S6q7"};